exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".transport-rate-heading[data-v-328d6566]{display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap}.transport-rate-heading h2[data-v-328d6566]{margin-bottom:0}.transport-rate-heading__views i[data-v-328d6566]{margin-right:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-328d6566","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"silenceDeprecations":["legacy-js-api","import","global-builtin","color-functions","slash-div"],"quietDeps":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/TransportRate/TransportRateList.vue
// module id = 1016
// module chunks = 0